import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetcharticle, getArticle } from '../../reducers/resumeSlice'
import $ from 'jquery'

export default function BlogPage() {
    const selectArticle = useSelector(getArticle)
    console.log(selectArticle);

    const dispatch = useDispatch()

    const backblog = () => {
        dispatch(fetcharticle({ article: '' }));
        localStorage.removeItem("article");
        $(".animated-section").removeClass("section-active");
        $(".blog").addClass("section-active");
        $(".animated-section").removeClass("custom-anim");
    }

    if (selectArticle === null) {
        return <div>loading</div>
    }
    else {
        return (
            <section data-id={`article-${selectArticle.id}`} className="animated-section article L90">
                <div className="section-content" >
                    <div className="page-title">
                        <h2>{selectArticle.name}</h2>
                    </div>
                    <a href='#blog' className='back-btn mb-3' onClick={() => backblog()}>برگشت به صفحه قبل</a>
                    <div className="blog-item position-relative ">
                        <div className="post-img position-relative overflow-hidden">
                            <p className="d-block">
                                {selectArticle?.iso_image != null ? (
                                    <img src={`https://amirsabit.4api.ir/uploads/Blog/${selectArticle.iso_image}`} title={selectArticle.name} alt={selectArticle.name} className="img-fluid w-100 d-block" />
                                ):<img src={`https://amirsabit.4api.ir/uploads/Blog/webeto_1697704866.jpg`} alt="" title="" className="img-fluid" />
                                }
                            </p>
                            <div className="category">
                                <span className="d-inline-block">{selectArticle.category}</span>
                            </div>
                            <div className="mask"></div>
                        </div>
                        <div className="post-info">
                            <div className="date text-start">{selectArticle.date}</div>
                            {/* <div className="post-title">
                                {selectArticle.name}
                            </div> */}
                            <p className="post-description">
                                {selectArticle.description}
                            </p>
                        </div>
                    </div>
                </div>
            </section >
        )
    }
    /* return (
        <></>
        // {selectArticle &&
        //     <section data-id={ `article-${selectArticle.id}` } className = "animated-section article" >
        // < div className = "section-content" >
        //         <div className="page-title">
        //             <h2>وبلاگ</h2>
        //         </div>

        //         <div className="blog-item position-relative ">
        //             <div className="post-img position-relative overflow-hidden">
        //                 <p className="d-block">
        //                     <img src={`../../assets/img/${item.iso_image}`} title={item.name} alt={item.name} className="img-fluid" />
        //                 </p>
        //                 <div className="category">
        //                     <span className="d-inline-block">{item.category}</span>
        //                 </div>
        //                 <div className="mask"></div>
        //             </div>
        //             <div className="post-info">
        //                 <div className="date">{item.date}</div>
        //                 <div className="post-title">
        //                     {item.name}
        //                 </div>
        //             </div> 
        //         </div>

        //     </div >
        // </section >
        // }

    ) */
}
